
import labels from '../../../../data/labels';
import { Prompt } from '../../models/PromptTypes';
import Button, { ButtonThemes } from '../../../../ui/button/Button';
import Modal from '../../../../ui/modal/Modal';
import styles from './PromptViewModal.module.scss';
import ChipList from '../../../../ui/chip-list/ChipList';
import { Status } from '../../../../helpers/statusHelpers';
import ReactMarkdown from 'react-markdown';

type PromptViewModalProps = {
    isOpen: boolean;
    onClose: () => void;
    prompt: Prompt | null;
    assistantTitle?: string;
    onTry: (prompt: Prompt) => void;
};

const PromptViewModal: React.FC<PromptViewModalProps> = ({
    isOpen,
    onClose,
    prompt,
    assistantTitle,
    onTry,
}) => {
    if (!prompt) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            headline={prompt.title}
            className={styles.content}
            size="medium"
            body={(
                <div className={styles['body-content']}>
                    <h5>{`${labels.filterAssistant}: ${assistantTitle}`}</h5>
                    {prompt.tags &&
                        prompt.tags.split(',').filter(Boolean).length > 0 && (
                            <ChipList
                                chips={prompt.tags
                                    .split(',')
                                    .filter(Boolean)
                                    .map(label => ({
                                        label: label.charAt(0).toUpperCase() + label.slice(1),
                                        theme: 'light' as Status,
                                    }))
                                }
                                minChipWidth={30}
                            />
                        )}
                    <ReactMarkdown>
                        {prompt.content}
                    </ReactMarkdown>
                </div>)}

            footer={(
                <Button
                    label={labels.promptModalTryPromptButton}
                    theme={ButtonThemes.primary}
                    onClick={() => onTry(prompt)}
                />
            )}
        />
    );
};

export default PromptViewModal;
